import React from "react"

const Page2Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div className='mt-2 font-family-acumin font-18 line-height-24'>1 / 4</div>
        <div className='mt-2 font-16 line-height-20 font-uppercase'>La mobilità elettrica</div>
        <div className='mt-2 font-44 line-height-58 font-family-acumin font-weight-900'>
          Auto con una marcia in più
        </div>
        <div className='mt-4 mb-5 font-20 line-height-26'>
          La ricerca di una soluzione sostenibile,
          alternativa ai veicoli a combustibili fossili
          trova una via d’uscita nell’elettrico.
        </div>
      </div>
    </div>
  )
}

export default Page2Mobile
